import Crud from '../components/gptLogs/Crud.vue'

let routes = {
    path: '/gptLogs',
    component: resolve => require(['../components/layout/AdminApp'], resolve),
    children: [
        {
            path: '/gptLogs',
            name: 'GPT logs',
            component: Crud
        },
    ]
};


export default routes



// WEBPACK FOOTER //
// ./src/router/gptLogs.js